import { useEffect, useRef } from 'react'
import { useLogin } from '@refinedev/core'
import { Layout, Space, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import TelegramLoginButton from 'react-telegram-login'

import { I18N_GENERIC_NS, manualHref } from '../i18n'

import { ReactComponent as ADGVLogo } from '../icons/adgvLogo.svg'

import { layoutBackgroundStyle } from '../theme'

// Same OAuth client as the bot backend (settings.GOOGLE_CLIENT_ID) and admin app.
const GOOGLE_CLIENT_ID = '1013127585776-0f2gehba18mebcai62pktk6tmetfvmsc.apps.googleusercontent.com'

// Keep both auth buttons visually aligned.
const BUTTON_WIDTH = 240
const HINT_COLOR = '#FFFFFF'

const GoogleLoginButton = ({ onLogin }) => {
	const divRef = useRef(null)

	useEffect(() => {
		if (typeof window === 'undefined' || !window.google || !divRef.current) return

		try {
			window.google.accounts.id.initialize({
				ux_mode: 'popup',
				client_id: GOOGLE_CLIENT_ID,
				callback: res => {
					if (res.credential) onLogin(res)
				}
			})
			window.google.accounts.id.renderButton(divRef.current, {
				theme: 'outline',
				size: 'large',
				type: 'standard',
				shape: 'pill',
				width: BUTTON_WIDTH
			})
		} catch (error) {
			console.error('Google button init failed', error)
		}
	}, [onLogin])

	return <div ref={divRef} />
}

const LoginPage = () => {
	const { mutate: login } = useLogin()
	const { t } = useTranslation([I18N_GENERIC_NS])

	const handleTelegramResponse = response => login(response)

	return (
		<Layout
			style={{
				height: '100vh',
				justifyContent: 'center',
				alignItems: 'center',
				...layoutBackgroundStyle
			}}
		>
			<Space direction='vertical' align='center' size='large'>
				<ADGVLogo />
				<Space direction='vertical' align='center' size='small' style={{ width: BUTTON_WIDTH }}>
					<TelegramLoginButton
						dataOnauth={handleTelegramResponse}
						botName={process.env.REACT_APP_BOT_NAME}
						cornerRadius={20}
					/>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 8,
							width: BUTTON_WIDTH,
							margin: '4px 0'
						}}
					>
						<span style={{ flex: 1, display: 'block', height: 1, backgroundColor: HINT_COLOR }} />
						<Typography.Text style={{ color: HINT_COLOR, fontSize: 12, letterSpacing: 1 }}>
							{t('or')}
						</Typography.Text>
						<span style={{ flex: 1, display: 'block', height: 1, backgroundColor: HINT_COLOR }} />
					</div>
					<GoogleLoginButton onLogin={login} />
					<Typography.Text style={{ color: HINT_COLOR, fontSize: 11, textAlign: 'center', lineHeight: 1.3 }}>
						{t('telegram_browser_warning')}
					</Typography.Text>
					{/* Ссылка на руководство: до входа её больше негде взять — пункт меню в сайдбаре
					    доступен только уже залогиненному. Текстом, а не кнопкой, чтобы не спорить
					    визуально с двумя кнопками входа выше. Цвет задан инлайном: он перебивает
					    и базовый, и hover-цвет ссылки из antd, аффорданс держится на подчёркивании. */}
					<Typography.Link
						href={manualHref}
						target='_blank'
						rel='noreferrer'
						style={{ color: HINT_COLOR, fontSize: 12, textDecoration: 'underline' }}
					>
						{t('manual')}
					</Typography.Link>
				</Space>
			</Space>
		</Layout>
	)
}

export default LoginPage
